var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBidirectionalEnterpriseEnterpriseplus = function SvgBidirectionalEnterpriseEnterpriseplus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 8h24v24H8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.355 23.354l2.79 2.79a.495.495 0 00.85-.35v-1.79h6.01a1 1 0 000-2h-6.01v-1.79a.495.495 0 00-.85-.35l-2.79 2.79a.501.501 0 000 .7zm13.66-7.35h-6.01a1 1 0 100 2h6.01v1.79a.495.495 0 00.85.35l2.78-2.79a.513.513 0 000-.71l-2.78-2.79a.497.497 0 00-.85.35z",
    fill: "#fabc3c"
  })));
};
export default SvgBidirectionalEnterpriseEnterpriseplus;